import React from "react";
import { Box, Button, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import logger from "../../utils/logger";

// Error boundary around the lazy-loaded routes. Its main job: after a
// redeploy, an open tab's old hashed chunk URLs 404 and the lazy import
// rejects — without a boundary the user is stuck on a blank screen. A
// reload picks up the new asset manifest and fixes it.
class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logger.error("Route render failed:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            px: 3,
            textAlign: "center",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Something went wrong loading this page
          </Typography>
          <Typography variant="body1" color="text.secondary">
            A new version of JobHarvest may have just been released. Reloading
            usually fixes this.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<RefreshIcon />}
            onClick={() => window.location.reload()}
          >
            Reload page
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
